<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <form [formGroup]="travelInfoForm" autocomplete="off">
    <div class="request-details">
      <mat-grid-list cols="4" rowHeight="66.5px" gutterSize="8px">
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput [matDatepicker]="datePicker" [min]="minDate" formControlName="date" placeholder="Date" (dateChange)="onTravelDateChange($event)" required>
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
            <mat-error *ngIf="travelInfoForm.get('date').invalid && (travelInfoForm.get('date').dirty || travelInfoForm.get('date').touched)">
              Date is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput formControlName="flightNumber" placeholder="Flight Number" required>
            <mat-error *ngIf="travelInfoForm.get('flightNumber').invalid && (travelInfoForm.get('flightNumber').dirty || travelInfoForm.get('flightNumber').touched)">
              Flight Number is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-checkbox formControlName="protocolArrival" (change)="onProtocolChange($event,'arrival')">Arrival</mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-checkbox formControlName="protocolDeparture" (change)="onProtocolChange($event,'departure')">Departure</mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field class="small-text">
            <input matInput type="time" formControlName="timeETA" placeholder="Time ETA" (change)="onTravelTimeChange($event)">
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field class="small-text">
            <input matInput type="time" formControlName="timeETD" placeholder="Time ETD" (change)="onTravelTimeChange($event)">
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <mat-form-field>
            <input matInput formControlName="flightOrDetails" placeholder="Airline/Terminal">
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="travelInfoForm.get('protocolArrival').value">
          <mat-form-field>
            <input matInput formControlName="accommodation" placeholder="Accommodation">
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="right-aligned-actions">
  <button mat-raised-button (click)="onCancel()" class="btn">Cancel</button>
  <button mat-raised-button (click)="onSubmit()" class="btn btn-primary">Save Changes</button>
</mat-dialog-actions>